import type {
  GetMediaGalleryItemServiceConfig,
  MediaGalleryListServiceConfig,
} from '@/services/httpServices/MediaGalleryServices/types';

import { createQueryKey } from './queryKeyUtils';

export function mediaGalleryListKeys(params?: MediaGalleryListServiceConfig) {
  return createQueryKey(['mediaGalleryList'], params);
}

export function mediaGalleryItemKeys(params?: GetMediaGalleryItemServiceConfig) {
  return createQueryKey(['mediaGalleryItem'], params);
}
